import formReducer, {
  emptyMultiInputField,
  emptySelectField,
  emptySingleInputField,
  formHelperMethodFactory,
} from 'reducers/FormReducer/FormReducer'
import {
  BaseValidationField,
  FormReducerMultiTextField,
  FormReducerSelectField,
  FormReducerSingleTextField,
  PickByType,
  ValidationObject,
  withValidationFactory,
} from 'reducers/FormReducer/utils'

export interface BrandLanguageFormReducerState {
  region: FormReducerSelectField
  replacement: FormReducerSingleTextField
  patterns: FormReducerMultiTextField
}

type PickBrandLanguageStateField<T> = PickByType<BrandLanguageFormReducerState, T>

// Define the keys of the fields that match the correct element types
export type UpdateBrandLanguageInputField = PickBrandLanguageStateField<FormReducerSingleTextField>
export type UpdateBrandLanguageSelectField = PickBrandLanguageStateField<FormReducerSelectField>
export type UpdateBrandLanguageMultiInputField = PickBrandLanguageStateField<FormReducerMultiTextField>

// Get the keys of the fields that have a value and an error field
export type ContentBlockValidationFields = BaseValidationField<BrandLanguageFormReducerState>

export const defaultBrandLanguageErrorObject: ValidationObject<'BrandLanguageFormReducerState'> = {}
const withValidation = withValidationFactory(defaultBrandLanguageErrorObject)

// Define the initial state of the form
export const emptyBrandLanguageFormReducerState: BrandLanguageFormReducerState = {
  region: withValidation({ ...emptySelectField, value: 'all' }, 'region', ['requiredField'], []),
  patterns: withValidation(emptyMultiInputField, 'patterns', ['requiredField'], []), //label find
  replacement: withValidation(emptySingleInputField, 'replacement', ['requiredField'], []),
}

const brandLanguageFormReducer = formReducer<'BrandLanguageFormReducerState'>
export const brandLanguageFormHelperFunctions = formHelperMethodFactory<'BrandLanguageFormReducerState'>()

export default brandLanguageFormReducer
